import React from 'react';
import { createUseStyles } from 'react-jss';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
import PropTypes from 'prop-types';

const DropzoneArea = ({ t, }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="36" fill="currentColor" className="bi bi-upload" viewBox="0 0 16 16">
          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
          <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
        </svg>
      </div>
      <div className={classes.mainDescription}>
        {t('upload')}
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    color: '#57C2F0',
    width: '100%',
    maxWidth: '551px',
    height: '150px',
    border: '2px dashed',
    borderColor: '#57C2F0',
    borderRadius: '5px',
    cursor: 'pointer',
    backgroundColor: 'rgba(87, 194, 240, 0.08)',
    marginTop: '4em',
  },
  iconContainer: {
    color: '#57C2F0',
    textAlign: 'center',
    marginTop: '2em',
  },
  mainDescription: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '21px',
    marginTop: '0.5em',
  },
});
DropzoneArea.propTypes = {
  t: PropTypes.func.isRequired,
}
export default withScopedTranslations('ad_vehicle_description')(DropzoneArea);
